import { type FC, useState } from 'react'
import classNames from 'classnames'
import { getIntegrationDisplayName } from '../../../../../../common/integrations'
import { Button } from '../../../../../../components/Button/Button'
import { type IntegrationWorkflowTemplate } from '../../../../../../models/IntegrationWorkflow'
import { type IntegrationWorkflowTarget } from './integrationWorkflow'
import { StartWorkflowForm } from './StartWorkflowForm'

interface NewWorkflowTabProps {
  target: IntegrationWorkflowTarget
  templates: IntegrationWorkflowTemplate[]
  onStarted: (templateId: string) => void
}

export const NewWorkflowTab: FC<NewWorkflowTabProps> = ({ target, templates, onStarted }) => {
  const [openTemplateId, setOpenTemplateId] = useState<string | null>(null)

  if (!templates.length) {
    return (
      <div className='p-4 text-center paragraph-small zocks-text-gray-600'>
        There are no workflow templates in {getIntegrationDisplayName(target.serviceId)} yet.
      </div>
    )
  }

  return (
    <div className='border zocks-border-color-gray-300 rounded-2 mt-3'>
      {templates.map((template, index) => (
        <div key={template.id} className={classNames({ 'border-top zocks-border-color-gray-300': index > 0 })}>
          {template.id === openTemplateId ? (
            <div className='d-flex flex-column gap-3 px-4 py-3'>
              <div className='d-flex align-items-center justify-content-between gap-3'>
                <span className='paragraph-medium bold'>{template.name}</span>
                <Button variant='borderless' className='button-small' aria-label={`Close ${template.name}`} onClick={() => setOpenTemplateId(null)}>
                  <i className='bi bi-x-lg' />
                </Button>
              </div>
              <StartWorkflowForm target={target} template={template} onStarted={() => onStarted(template.id)} />
            </div>
          ) : (
            <button
              type='button'
              className='btn w-100 d-flex align-items-center justify-content-between gap-3 border-0 rounded-0 px-4 py-3'
              aria-expanded={false}
              onClick={() => setOpenTemplateId(template.id)}
            >
              <span className='paragraph-medium bold text-start'>{template.name}</span>
              <i className='bi bi-chevron-down' aria-hidden='true' />
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
